<template>
  <div>
    <b-table-simple caption-top responsive bordered>
      <b-thead head-variant="light">
        <b-tr>
          <b-th class="text-center">STT</b-th>
          <b-th class="text-center">Reward Type</b-th>
          <b-th class="text-center">Reward Image</b-th>
          <b-th class="text-center">Action</b-th>
        </b-tr>
      </b-thead>
      <b-tbody v-model="list" tag="tbody">
        <b-tr v-for="(item, index) in list" :key="item._id || index">
          <b-td scope="row" class="text-center">{{ index + 1 }}</b-td>
          <b-td class="text-center">
            {{ item.type }}
          </b-td>
          <b-td class="text-center">
            <b-img-lazy class="mt-2" :src="item.image" alt="reward image" fluid width="320" />
          </b-td>
          <b-td class="text-center">
            <b-button
              variant="gradient-warning"
              style="margin-right: 5px"
              class="btn-icon"
              @click="editMissionReward(item._id)"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-button
              @click="confirmDelete(item._id)"
              variant="gradient-danger"
              class="btn-icon"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>
<script>
import service from "../../service";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  props: {
    mission_rewards: { type: Array, required: true },
  },
  data() {
    return {
      list: this.mission_rewards.length ? mission_rewards : [],
    };
  },
  watch: {
    mission_rewards() {
      this.list = this.mission_rewards;
    },
    list(value) {
      this.$emit("changeMission", value);
    },
  },
  methods: {
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Are you sure ?", {
          title: "Please Confirm",
          size: "md",
          okVariant: "danger",
          okTitle: "Yes",
          cancelTitle: "No",
          cancelVariant: "outline-secondary",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.deleteMission(id);
          }
        });
    },
    async deleteMission(id) {
      await service.delete({ id: id });
      this.$emit("getList");
    },
    editMissionReward(id) {
      this.$router.push({
        name: "mission-reward-detail",
        params: { reward_id: id },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.sortable-chosen {
  background-color: bisque;
}
</style>
